import React, { useEffect, useRef, useState } from "react";

const Counter = ({ target }) => {
    const [count, setCount] = useState(0);
    const counterRef = useRef();
    const duration = 500; // Duration of the animation in milliseconds

    const countUp = (start, target, duration) => {
        const increment = target / (duration / 10);
        let current = start;

        const updateCounter = () => {
            current += increment;
            if (current >= target) {
                setCount(target);
                clearInterval(interval);
            } else {
                setCount(Math.ceil(current));
            }
        };

        const interval = setInterval(updateCounter, 10);
    };

    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <=
                (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    useEffect(() => {
        const onScroll = () => {
            if (isInViewport(counterRef.current)) {
                countUp(0, target, duration);
                window.removeEventListener("scroll", onScroll);
            }
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [target, duration]);

    return (
        <div ref={counterRef} className="counter">
            {count}
        </div>
    );
};

export default Counter;
